import React from 'react';



const LiveEscalationQueue = ({ escalations }) => {
  const getPriorityColor = (priority) => {
    const colors = {
      'Critical': 'bg-error text-error-foreground',
      'High': 'bg-warning text-warning-foreground',
      'Medium': 'bg-accent text-accent-foreground',
      'Low': 'bg-muted text-muted-foreground'
    };
    return colors?.[priority] || 'bg-muted text-muted-foreground';
  };

  const getStatusIcon = (status) => {
    const icons = {
      'Assigned': 'UserCheck',
      'In Progress': 'Clock',
      'Pending': 'AlertCircle',
      'Waiting': 'Pause'
    };
    return icons?.[status] || 'Circle';
  };

  const getSLAColor = (minutes) => {
    if (minutes < 10) return 'text-error';
    if (minutes < 30) return 'text-warning';
    return 'text-success';
  };

  return;









































































};

export default LiveEscalationQueue;